import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { LookUpKeyValueforDomainList } from '../model/lov';
import { filterRequest, filterRTVRequest, OrderMaster, OrderSummay, OrderSearch, InventoryParam, InventoryAllocationConfigResponse, OrderErrorResponse, OrderConsolidationSearchParams, OrderConsolidationResponseList, PicklistRequest, PickListResponse, PicklistInquiryRequest, PicklistInquiryResponse, PrintPicklistResponse, PrintPicklistRequest, PutListRequest, PutListResponse } from '../model/order';
import { HttpUtilsService } from '../shared/services/http-utils.service';
import { OrderAttribute } from '../model/packstation';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  userSelectedIndex: number;
  userSelectedIndex$ = new BehaviorSubject(null);
  filterRequest = new filterRequest();
  filterRTVRequest = new filterRTVRequest();
  onchangeDate: boolean = false;
  isCurrentTime: boolean = false;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService
  ) { }

  submitOrder(orderMaster: OrderMaster): Observable<OrderMaster> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ORDER_SERVICE'
    });
    const options = { headers };
    return this.http.post<any>(environment.apiOrderURL, JSON.stringify(orderMaster), options);
  }


  getOrderKeyValue(domainList: string[],
    domainCode?: string,
    codeActive?: string,
    facility?: string,
    customerId?: string,
    buId?: string,
): Observable<LookUpKeyValueforDomainList> {
  const httpOptions = {
    headers: {
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    },
    params: { active: 'Y', lookupNames: domainList ,fcyId: facility ? facility : '0',
      cusId: customerId ? customerId : '0',
      buId: buId ? buId : '0'  }
  };

    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
  }

  getSelectedCustomer() {
    return localStorage.getItem('selectedCustomer') ? JSON.parse(localStorage.getItem('selectedCustomer')) : '';
  }

  getSelectedBusinessUnit() {
    return localStorage.getItem('selectedBusinessUnit') ? JSON.parse(localStorage.getItem('selectedBusinessUnit')) : '';
  }

  getSelectedFacility() {
    return localStorage.getItem('selectedFacility') ? JSON.parse(localStorage.getItem('selectedFacility')) : '';
  }

  getOrderSummary(orderSearch: OrderSearch): Observable<OrderSummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: this.httpUtils.cleanParams({
        customerId: orderSearch.cusId,
        buId: (this.getSelectedBusinessUnit().buId?.toString() == undefined) ? "" : this.getSelectedBusinessUnit().buId?.toString(),
        fcyId: (this.getSelectedFacility().facilityID?.toString() == undefined) ? "" : this.getSelectedFacility().facilityID?.toString(),
        responseFilter: orderSearch.responseFilter,
        page: orderSearch.pageNumber,
        pageLimit: '10',
        orderNumber: orderSearch.ordNumOrCustOrdNum,
        customerOrderNumber: orderSearch.ordNumOrCustOrdNum,
        externalPoNumber: orderSearch.ordNumOrCustOrdNum,
        vendorRma: orderSearch.vendorRma,
        waveId: orderSearch.waveId,
        exactOrderType: orderSearch.exactOrderType,
        orderType: orderSearch.ordType,
        orderStatus: orderSearch.orderStatus,
        orderPriority: orderSearch.orderPriority,
        orderAttributes: orderSearch.orderAttributes,
        fromDate: orderSearch.fromDate,
        toDate: orderSearch.toDate
      })
    };

    return this.http.get<OrderSummay>(environment.apiOrderURL, httpOptions);
  }

  getInventoryConfig(invParam: InventoryParam): Observable<InventoryAllocationConfigResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: {
        custId: invParam.custId,
        buId: invParam.buId,
        fcyId: invParam.fcyId
      }
    };

    return this.http.get<InventoryAllocationConfigResponse>(environment.apiOrderURL+'/invconfig', httpOptions);
  }

  updateOrder(orderMaster: OrderMaster): Observable<OrderMaster> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ORDER_SERVICE'
    });
    const options = { headers };
    return this.http.patch<any>(environment.apiOrderURL, JSON.stringify(orderMaster), options);
  }

  validateAddress(address): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    });
    const options = { headers };

    return this.http.post<any>(environment.apiAddressValidationURL, JSON.stringify(address), options);
  }


  getOrderError(
    cusId: number,
    orderErrorId: number
  ):Observable<OrderErrorResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        custId: cusId != undefined ? cusId.toString() : '0',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      },
      params: { orderErrorId: orderErrorId != undefined ? orderErrorId.toString() : '0' }
    };
    return this.http.get<OrderErrorResponse>(
      environment.apiOrderURL+"/error",
      httpOptions
   );
  }


  getOrderConsolidation(orderConsolidationSearchParams: OrderConsolidationSearchParams): Observable< OrderConsolidationResponseList>{
    const requestParam : any  = orderConsolidationSearchParams;
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')

      },
      params: requestParam
    };
    return this.http.get<OrderConsolidationResponseList>(environment.apiOrderURL + '/orderConsolidation' , httpOptions);
  }

  generatePickList(custId : string ,picklistRequest: PicklistRequest) : Observable <PickListResponse>{

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      FSC_USER: localStorage.getItem('USERID'),
      CUST_ID : custId

    });
    const options = { headers };
    return this.http.patch<any>(environment.apiOrderURL +'/generatePickList', JSON.stringify(picklistRequest), options);

  }



  generatePutList(putListReq: PutListRequest): Observable<PutListResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),

      },
      params: {
        asnId: putListReq.asnId,
        packStation: putListReq.packStation
      }
    };
    return this.http.get<PutListResponse>(environment.apiOrderURL +'/printputlist', httpOptions);
  }

  getPicklistInquiry(picklistInquiry: PicklistInquiryRequest): Observable<PicklistInquiryResponse>{
    const requestParam : any  = picklistInquiry;
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')
      },
      params: requestParam
    };
    return this.http.get<PicklistInquiryResponse>(environment.apiOrderURL+'/picklistenquiry', httpOptions);
  }

  getprintPicklist(picklist: PrintPicklistRequest): Observable<PrintPicklistResponse>{
    const requestParam : any  = picklist;
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID')

      },
      params: requestParam
    };
    return this.http.get<PrintPicklistResponse>(environment.apiOrderURL+'/printpicklist', httpOptions);
  }

   clearFilterRequest() {
    this.filterRequest = new filterRequest();
  }

  clearFilterRTVRequest() {
    this.filterRTVRequest = new filterRTVRequest();
  }
  updateOrderStatus(orderId: string): Observable<OrderMaster> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
      SERVICE_NAME: 'ORDER_SERVICE'
    });
  
    const url = `${environment.apiOrderURL}/releaseOrder/${orderId}`;
    
    return this.http.patch<OrderMaster>(url, null, { headers });
  }
}

